export enum CustomerStatuses {
    Active = 1,
    Inactive = 2,
    Unverified = 3,
    Draft = 4
}